import { put } from 'redux-saga/effects'
import { fetchMoreChatsAction, setHasMoreChatsAction } from '../../actions'
import { Chat } from '../../types'
import { fetchMore, FetchMoreResponse } from '../_http/chat'

const CHATS_LIMIT = 13

export function* fetchMoreChatsSaga(action: ReturnType<typeof fetchMoreChatsAction.request>) {
  yield put(setHasMoreChatsAction({ state: false, status: action.payload.status }))

  try {
    const { lastChat, ownerId, status, operatorId, campaignIds, departmentId } = action.payload

    const { chats, hasMore }: FetchMoreResponse = yield fetchMore({
      ownerId,
      campaignIds,
      status,
      departmentId,
      startAfter: lastChat.updatedAt,
      operatorId,
      limit: CHATS_LIMIT
    })

    if (hasMore) {
      yield put(setHasMoreChatsAction({ state: true, status }))
    }
    const hasLastChatIntoCurrent = yield hasLastChatIntoCurrentChats(lastChat, chats)
    yield put(fetchMoreChatsAction.success(hasLastChatIntoCurrent ? { chats: [], status } : { chats, status }))
  } catch (error) {
    console.log('Error fetchMoreChatsSaga:', error)
    yield put(fetchMoreChatsAction.failure({ status: action.payload.status }))
  }
}

async function hasLastChatIntoCurrentChats(lastChat: Chat, chats: Chat[]) {
  return chats.some(chat => chat.id === lastChat.id)
}
